export default function () {
	document.addEventListener('DOMContentLoaded', () => {
		const mobileButton = document.getElementById('toggle-mobile-menu');
		if (mobileButton) {
			mobileButton.addEventListener('click', () => {
				document.body.classList.toggle('is-mobile-nav-open');
			});
		}
	});
}
